/* Oshea Easy COD — كاش عند الاستلام (no dependencies) */
(function () {
  'use strict';
  var C = window.OSH_COD || {};
  var KEYS = ['المنتج الاول', 'المنتج الثاني', 'المنتج الثالث'];
  var MAXQ = 20;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function num(c) { c = Math.round(c); return c % 100 === 0 ? String(c / 100) : (c / 100).toFixed(2); }
  function money(c) { return '<span class="o-num">' + num(c) + '</span> د.أ'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function digits(s) {
    return String(s || '')
      .replace(/[٠-٩]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.indexOf(d); })
      .replace(/[۰-۹]/g, function (d) { return '۰۱۲۳۴۵۶۷۸۹'.indexOf(d); });
  }
  function normPhone(s) {
    var d = digits(s).replace(/[^\d+]/g, '').replace(/^\+/, '').replace(/^00/, '');
    if (/^9627[789]\d{7}$/.test(d)) d = '0' + d.slice(3);
    if (/^7[789]\d{7}$/.test(d)) d = '0' + d;
    return /^07[789]\d{7}$/.test(d) ? d : null;
  }
  function arName(t) { t = String(t || ''); var i = t.lastIndexOf(' - '); var a = i > -1 ? t.slice(i + 3) : t; return /[؀-ۿ]/.test(a) ? a.trim() : t; }

  /* ---------- landing attribution (kept for the order note) ---------- */
  var ATTR = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'ttclid', 'ScCid', 'gclid'];
  try {
    var qp = new URLSearchParams(location.search), got = {}, any = false;
    ATTR.forEach(function (k) { var v = qp.get(k); if (v) { got[k] = v.slice(0, 200); any = true; } });
    if (any) sessionStorage.setItem('osh_cod_attr', JSON.stringify(got));
    if (!sessionStorage.getItem('osh_cod_land')) sessionStorage.setItem('osh_cod_land', JSON.stringify({ url: location.href.slice(0, 400), ref: document.referrer.slice(0, 300) }));
  } catch (e) { }
  function attribution() {
    var o = {};
    try { o = JSON.parse(sessionStorage.getItem('osh_cod_attr') || '{}'); var l = JSON.parse(sessionStorage.getItem('osh_cod_land') || '{}'); o.landing = l.url; o.referrer = l.ref; } catch (e) { }
    return o;
  }

  /* ---------- ad pixels (fire only if the pixel is on the page) ---------- */
  function track(ev, d) {
    try { if (window.fbq) window.fbq('track', ev, { value: d.value, currency: 'JOD', content_ids: d.ids, content_type: 'product', num_items: d.n }, d.eid ? { eventID: String(d.eid) } : undefined); } catch (e) { }
    try { if (window.snaptr) window.snaptr('track', ev === 'Purchase' ? 'PURCHASE' : 'START_CHECKOUT', { price: d.value, currency: 'JOD', transaction_id: d.eid, number_items: d.n }); } catch (e) { }
    try { if (window.ttq) window.ttq.track(ev === 'Purchase' ? 'CompletePayment' : 'InitiateCheckout', { value: d.value, currency: 'JOD', content_type: 'product' }); } catch (e) { }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('oshea_cod_' + ev.toLowerCase(), d); } catch (e) { }
  }

  /* ---------- offer pricing for a single product (2 for p2 / 3 for p3) ---------- */
  function plan(st) {
    var n = st.qty, u = st.price;
    var ok2 = !!(st.offer && C.p2 && C.p2.ok && C.p2.vid && C.p2.price > 0);
    var ok3 = !!(st.offer && C.p3 && C.p3.ok && C.p3.vid && C.p3.price > 0);
    var cost = [0], ch = [0];
    for (var k = 1; k <= n; k++) {
      cost[k] = cost[k - 1] + u; ch[k] = 1;
      if (ok2 && k >= 2 && cost[k - 2] + C.p2.price < cost[k]) { cost[k] = cost[k - 2] + C.p2.price; ch[k] = 2; }
      if (ok3 && k >= 3 && cost[k - 3] + C.p3.price < cost[k]) { cost[k] = cost[k - 3] + C.p3.price; ch[k] = 3; }
    }
    var c = { 1: 0, 2: 0, 3: 0 }, r = n;
    while (r > 0) { c[ch[r]]++; r -= ch[r]; }
    var items = [], lines = [];
    function props(m) { var p = {}; for (var i = 0; i < m; i++) p[KEYS[i]] = st.offer; return p; }
    if (c[3]) { items.push({ variant_id: +C.p3.vid, quantity: c[3], properties: props(3) }); lines.push({ t: 'عرض 3 منتجات', m: st.name + ' × 3', q: c[3], p: c[3] * C.p3.price }); }
    if (c[2]) { items.push({ variant_id: +C.p2.vid, quantity: c[2], properties: props(2) }); lines.push({ t: 'عرض منتجين', m: st.name + ' × 2', q: c[2], p: c[2] * C.p2.price }); }
    if (c[1]) { items.push({ variant_id: +st.vid, quantity: c[1], properties: {} }); }
    return { items: items, lines: lines, total: cost[n], regular: n * u, singles: c[1] };
  }

  /* ---------- dialog ---------- */
  var dlg, form, sumEl, totEl, errEl, goBtn, doneEl, st = null, busy = false;

  function setup() {
    dlg = $('[data-cod]'); if (!dlg) return false;
    form = $('[data-cod-form]', dlg); sumEl = $('[data-cod-sum]', dlg); totEl = $('[data-cod-tot]', dlg);
    errEl = $('[data-cod-err]', dlg); goBtn = $('[data-cod-go]', dlg); doneEl = $('[data-cod-done]', dlg);
    dlg.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    dlg.addEventListener('cancel', function (e) { if (busy) e.preventDefault(); });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && !busy) { dlg.close(); return; }
      var x = e.target.closest('[data-cod-close]'); if (x && !busy) { dlg.close(); return; }
      x = e.target.closest('[data-cod-step]');
      if (x && st && st.mode === 'item') { st.qty = Math.max(1, Math.min(MAXQ, st.qty + (+x.getAttribute('data-cod-step')))); render(); }
    });
    dlg.addEventListener('change', function (e) {
      if (e.target.matches('[data-cod-qty]') && st && st.mode === 'item') { st.qty = Math.max(1, Math.min(MAXQ, parseInt(digits(e.target.value), 10) || 1)); render(); }
    });
    $$('input,select,textarea', form).forEach(function (el) { el.addEventListener('input', function () { fieldErr(el.name, ''); }); });
    form.addEventListener('submit', submit);
    // prefill returning customers
    try { var s = JSON.parse(localStorage.getItem('osh_cod_me') || '{}'); ['name', 'phone', 'city', 'address'].forEach(function (k) { if (s[k] && form.elements[k]) form.elements[k].value = s[k]; }); } catch (e) { }
    return true;
  }

  function open(state) {
    if (!dlg && !setup()) return;
    st = state;
    form.hidden = false; doneEl.hidden = true; errEl.hidden = true;
    render();
    if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var f = $('[data-cod-qty]', dlg) || form.elements.name; if (f && window.innerWidth > 749) f.focus(); }, 40);
    track('InitiateCheckout', { value: (st.subtotal || 0) / 100, ids: ids(), n: count() });
  }

  function ids() { return st.mode === 'item' ? [String(st.vid)] : st.cart.items.map(function (i) { return String(i.variant_id); }); }
  function count() { return st.mode === 'item' ? st.qty : st.cart.item_count; }

  function render() {
    var html = '', sub, regular, fee = +C.fee || 0;
    if (st.mode === 'item') {
      var pl = plan(st); st.plan = pl; sub = pl.total; regular = pl.regular;
      html += '<div class="o-cod__item' + (st.img ? '' : ' o-cod__item--noimg') + '">' +
        (st.img ? '<span class="o-cod__img"><img src="' + esc(st.img) + '" alt="" width="56" height="56"></span>' : '') +
        '<div><div class="o-cod__nm">' + esc(st.name) + '</div>' + (st.meta ? '<div class="o-cod__meta">' + esc(st.meta) + '</div>' : '') + '</div>' +
        '<div class="o-cod__pr">' + money(sub) + (regular > sub ? '<s>' + money(regular) + '</s>' : '') + '</div></div>' +
        '<div class="o-cod__qtyrow"><span class="o-label" style="margin:0">الكمية</span>' +
        '<div class="o-qty" role="group" aria-label="الكمية">' +
        '<button type="button" aria-label="إنقاص الكمية" data-cod-step="-1"' + (st.qty <= 1 ? ' disabled' : '') + '>−</button>' +
        '<input type="number" inputmode="numeric" min="1" max="' + MAXQ + '" value="' + st.qty + '" aria-label="الكمية" data-cod-qty>' +
        '<button type="button" aria-label="زيادة الكمية" data-cod-step="1"' + (st.qty >= MAXQ ? ' disabled' : '') + '>+</button></div></div>';
      if (pl.lines.length) {
        html += '<p class="o-cod__deal">طُبّق العرض: ' + pl.lines.map(function (l) { return esc(l.t) + (l.q > 1 ? ' × ' + l.q : ''); }).join(' + ') + (pl.singles ? ' + ' + pl.singles + ' بالسعر العادي' : '') + '</p>';
      } else if (st.offer && st.qty === 1 && C.p2 && C.p2.ok && 2 * st.price > C.p2.price) {
        html += '<p class="o-cod__deal">اطلب قطعتين بـ' + money(C.p2.price) + ' بدل ' + money(2 * st.price) + ' — زِد الكمية</p>';
      }
    } else {
      var cart = st.cart; sub = cart.total_price; regular = cart.original_total_price || sub;
      cart.items.forEach(function (it) {
        var props = [];
        Object.keys(it.properties || {}).forEach(function (k) { var v = it.properties[k]; if (k.charAt(0) !== '_' && v) props.push(v); });
        var img = it.image ? String(it.image) + (String(it.image).indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        html += '<div class="o-cod__item' + (img ? '' : ' o-cod__item--noimg') + '">' +
          (img ? '<span class="o-cod__img"><img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy"></span>' : '') +
          '<div><div class="o-cod__nm">' + esc(arName(it.product_title)) + ' <span class="o-cod__meta">× <span class="o-num">' + it.quantity + '</span></span></div>' +
          (props.length ? '<div class="o-cod__meta">' + esc(props.join('، ')) + '</div>' : '') + '</div>' +
          '<div class="o-cod__pr">' + money(it.final_line_price) + '</div></div>';
      });
    }
    st.subtotal = sub;
    sumEl.innerHTML = html;
    var total = sub + fee;
    totEl.innerHTML = '<div><span>المجموع الفرعي</span><span>' + money(sub) + '</span></div>' +
      (regular > sub ? '<div class="o-cod__save"><span>وفّرت</span><span>' + money(regular - sub) + '</span></div>' : '') +
      '<div><span>التوصيل</span><span>' + (fee ? money(fee) : 'مجاني') + '</span></div>' +
      '<div class="o-cod__grand"><span>الإجمالي</span><span>' + money(total) + '</span></div>';
    goBtn.innerHTML = 'تأكيد الطلب — ' + money(total);
    st.total = total;
  }

  function fieldErr(name, msg) {
    var el = form.elements[name], p = $('.o-cod__err[data-for="' + name + '"]', form);
    if (el) el.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (p) { p.textContent = msg; p.hidden = !msg; }
  }

  function validate() {
    var v = {
      name: form.elements.name.value.trim().replace(/\s+/g, ' '),
      phone: normPhone(form.elements.phone.value),
      city: form.elements.city.value,
      address: form.elements.address.value.trim(),
      notes: form.elements.notes.value.trim()
    }, first = null, bad = function (k, m) { fieldErr(k, m); if (!first) first = form.elements[k]; };
    if (v.name.length < 3) bad('name', 'اكتب الاسم الكامل');
    if (!v.phone) bad('phone', 'اكتب رقم هاتف أردني صحيح، مثل 0791234567');
    if (!v.city) bad('city', 'اختر المدينة');
    if (v.address.length < 4) bad('address', 'اكتب العنوان بالتفصيل');
    if (first) { first.focus(); return null; }
    return v;
  }

  function submit(e) {
    e.preventDefault(); if (busy) return;
    errEl.hidden = true;
    var v = validate(); if (!v) return;
    if (!C.url) { showErr('نموذج الطلب غير مفعّل بعد. اطلب من خلال إتمام الطلب أو تواصل معنا.'); return; }
    var items = st.mode === 'item' ? st.plan.items : st.cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }; });
    if (!items.length) { showErr('السلة فاضية.'); return; }
    var payload = { mode: st.mode, items: items, customer: v, website: form.elements.website.value, client_total: st.total, attribution: attribution(), page: location.href.slice(0, 400) };
    busy = true; goBtn.setAttribute('aria-busy', 'true'); goBtn.innerHTML = 'جاري تأكيد طلبك…';
    try { localStorage.setItem('osh_cod_me', JSON.stringify({ name: v.name, phone: v.phone, city: v.city, address: v.address })); } catch (x) { }
    var ctl = window.AbortController ? new AbortController() : null, tm = setTimeout(function () { if (ctl) ctl.abort(); }, 40000);
    fetch(C.url, { method: 'POST', body: JSON.stringify(payload), redirect: 'follow', signal: ctl ? ctl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (!j || !j.ok) throw new Error((j && j.error) || ''); done(j, v); })
      .catch(function (x) {
        showErr((x && x.message) || 'تعذّر إرسال الطلب. تأكد من الاتصال بالإنترنت وحاول مرة ثانية.');
        busy = false; goBtn.removeAttribute('aria-busy'); render();
      })
      .then(function () { clearTimeout(tm); });
  }

  function showErr(m) { errEl.textContent = m; errEl.hidden = false; }

  function done(j, v) {
    busy = false; goBtn.removeAttribute('aria-busy');
    var no = $('[data-cod-done-no]', dlg), msg = $('[data-cod-done-msg]', dlg);
    if (j.order_name) { no.textContent = 'رقم الطلب ' + j.order_name; no.hidden = false; } else { no.hidden = true; }
    msg.textContent = 'شكرًا ' + v.name.split(' ')[0] + '! راح نتواصل معك على ' + v.phone + ' لتأكيد الطلب. الدفع كاش عند الاستلام.';
    form.hidden = true; doneEl.hidden = false; form.elements.notes.value = '';
    var h = $('[data-cod-done-t]', dlg); if (h) h.focus();
    var value = typeof j.total === 'number' ? j.total : st.total / 100;
    track('Purchase', { value: value, ids: ids(), n: count(), eid: j.order_id || j.order_name || String(Date.now()) });
    if (st.mode === 'cart') {
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }).then(refreshDrawer).catch(function () { });
    }
  }

  function refreshDrawer() {
    return fetch((C.root || '/') + '?sections=osh-cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['osh-cart-drawer']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-o-cart]', doc), cur = $('[data-o-cart]');
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        $$('[data-o-count]').forEach(function (c) { c.textContent = 0; c.hidden = true; });
      });
  }

  /* ---------- triggers ---------- */
  function fromItem(b) {
    return { mode: 'item', vid: +b.getAttribute('data-vid'), price: +b.getAttribute('data-price'), name: b.getAttribute('data-name'), meta: b.getAttribute('data-size') || '', img: b.getAttribute('data-img') || '', offer: b.getAttribute('data-offer') || '', qty: 1 };
  }
  function fromPdp(b) {
    var s = fromItem(b), f = b.closest('form');
    if (f) {
      var idEl = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]'), vj = f.querySelector('[data-o-variants]');
      if (idEl) s.vid = +idEl.value;
      if (q) s.qty = Math.max(1, Math.min(MAXQ, parseInt(q.value, 10) || 1));
      if (vj) {
        try {
          var v = JSON.parse(vj.textContent).filter(function (x) { return +x.id === s.vid; })[0];
          if (v) { if (!v.available) { alert('هذا الخيار غير متوفر حاليًا.'); return null; } s.price = v.price; s.meta = v.title; if (v.featured_image && v.featured_image.src) s.img = v.featured_image.src; }
        } catch (e) { }
      }
    }
    return s;
  }
  function fromCart(btn) {
    btn.setAttribute('aria-busy', 'true');
    var sc = $('[data-o-scrim]'); if (sc && !sc.hidden) sc.click(); // close the drawer first (releases its focus trap)
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.removeAttribute('aria-busy');
        if (!cart.item_count) { alert('السلة فاضية.'); return; }
        open({ mode: 'cart', cart: cart });
      })
      .catch(function () { btn.removeAttribute('aria-busy'); alert('تعذّر تحميل السلة، حاول مرة ثانية.'); });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-o-cod]'); if (!b) return;
    e.preventDefault();
    var m = b.getAttribute('data-o-cod');
    if (m === 'cart') { fromCart(b); return; }
    var s = m === 'pdp' ? fromPdp(b) : fromItem(b);
    if (s && s.vid && s.price) open(s);
  });
})();
